import { mapState } from "pinia";

// Lazy store resolution: a module-scope import here closes a cycle
// (stores -> components -> mixins -> classes). See scripts/find-import-cycles.py.
// eslint-disable-next-line global-require
const useBrandingStore = (...args) => require("%/dynamic-component-editor/stores/branding-store").default(...args);


const BrandedTextMixinStaging = {
  computed: {
    ...mapState(useBrandingStore, {
      brandingConfiguration: "configuration",
    }),
  },
};

export { BrandedTextMixinStaging };
